export default {
  'CUPON' (state) {
    return state.cupon
  },
  'CUPONS' (state) {
    return state.cupons
  }
}
